export const MEDIA_RADIUS = "rounded-[1rem] sm:rounded-[1.05rem]";

// The raised frame shared by every product screenshot and the demo video.
export const Frame = ({ className = "", children }) => (
  <div className={`relative rounded-[1.4rem] border border-white/[0.08] bg-gradient-to-b from-white/[0.07] to-white/[0.015] p-1.5 sm:p-2 shadow-[0_60px_120px_-60px_rgba(37,99,255,0.6),0_30px_60px_-34px_rgba(0,0,0,0.9)] ${className}`}>
    {children}
  </div>
);

// A real product screenshot, with a phone-sized and a desktop-sized version.
export function Shot({ name, h, alt, eager = false, sizes = "(min-width: 1024px) 720px, 100vw", className = "", testid }) {
  return (
    <Frame className={className}>
      <img src={`/home/${name}-1600.webp`} srcSet={`/home/${name}-800.webp 800w, /home/${name}-1600.webp 1600w`} sizes={sizes}
        width="1600" height={h} alt={alt} loading={eager ? "eager" : "lazy"} fetchPriority={eager ? "high" : "auto"} decoding="async"
        className={`block w-full h-auto ${MEDIA_RADIUS}`} data-testid={testid} />
    </Frame>
  );
}
